import * as THREE from "three";

export function createTube(curvePoints = []) {
  const geometry = createTubeGeometry(curvePoints);
  const material = createTubeMaterial();
  const tube = new THREE.Mesh(geometry, material);
  tube.name = "__tube__";

  tube.layers.set(1);
  return tube;
}

export function updateTube(mesh, curvePoints = []) {
  mesh.geometry.dispose();
  const updatedGeometry = createTubeGeometry(curvePoints);
  mesh.geometry = updatedGeometry;
}

function createTubeGeometry(curvePoints) {
  if (curvePoints < 2) return null;
  const curve = new THREE.CatmullRomCurve3(curvePoints);

  const tubularSegments = 64; // Number of segments along the tube
  const radius = 0.05; // Radius of the tube
  const radialSegments = 64; // Number of segments around the tube
  const closed = false; // Whether the tube should be a closed loop

  const tubeGeometry = new THREE.TubeGeometry(
    curve,
    tubularSegments,
    radius,
    radialSegments,
    closed,
  );

  return tubeGeometry;
}

function createTubeMaterial({ color = "white" } = {}) {
  const material = new THREE.MeshPhysicalMaterial({
    color, // Light blue tint for glass
    transmission: 1, // Light passes through the object
    opacity: 1, // Slightly transparent
    metalness: 0.1, // Non-metallic
    roughness: 0.5, // Smooth surface
    ior: 1.5, // Index of refraction for glass
    reflectivity: 1, // Highly reflective
    transparent: true, // Enable transparency
  });
  return material;
}
